import React from 'react';
import { Slider, Typography } from 'antd';

const { Text } = Typography;

const StyleSlider = ({
  label,
  leftLabel,
  rightLabel,
  value,
  onChange,
  disabled = false,
  color = '#1890ff', // New prop for color
}) => {
  return (
    <div className="style-slider" style={{ marginBottom: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Text style={{ fontSize: '11px', fontWeight: 800, color: '#444', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
          {label}
        </Text>
        <div style={{ 
          backgroundColor: '#fff', 
          padding: '2px 8px', 
          borderRadius: '4px', 
          border: '1px solid #eee',
          fontSize: '11px',
          fontWeight: 700,
          color: color,
          minWidth: '40px',
          textAlign: 'center'
        }}>
          {value}%
        </div>
      </div>
      <div style={{ position: 'relative', padding: '0 4px' }}>
        <Slider
          min={0}
          max={100}
          value={value}
          onChange={onChange}
          disabled={disabled}
          tipFormatter={null}
          trackStyle={{
            background: color,
            height: 4,
          }}
          railStyle={{
            background: '#f0f0f0',
            height: 4,
          }}
          handleStyle={{
            borderColor: color,
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            width: 14,
            height: 14,
            marginTop: -5,
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
          <Text style={{ fontSize: '9px', color: '#ccc', fontWeight: 600, letterSpacing: '0.05em' }}>
            {leftLabel?.toUpperCase()}
          </Text>
          <Text style={{ fontSize: '9px', color: '#ccc', fontWeight: 600, letterSpacing: '0.05em' }}>
            {rightLabel?.toUpperCase()}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default StyleSlider;
